/**
 * Утилиты для инициализации боевой системы
 * Вынесено из legacy-app.js для модульности
 */

/**
 * Инициализирует обработчики боевой системы
 * Вызывает настройку обработчиков модального окна, элементов управления
 * и планирует повторную попытку авторизации
 * 
 * @param {function} setupBattleModalHandlers - функция настройки обработчиков модального окна
 * @param {function} setupBattlePlaybackControls - функция настройки элементов управления
 * @param {function} scheduleAuthRetry - функция планирования повторной попытки авторизации
 */
export function initializeBattleHandlers(
  setupBattleModalHandlers,
  setupBattlePlaybackControls,
  scheduleAuthRetry
) {
  // Настраиваем обработчики модального окна боя
  if (typeof setupBattleModalHandlers === 'function') {
    setupBattleModalHandlers();
  }
  
  // Настраиваем элементы управления воспроизведением боя
  if (typeof setupBattlePlaybackControls === 'function') {
    setupBattlePlaybackControls();
  }
  
  // Планируем повторную попытку авторизации через 100мс
  if (typeof scheduleAuthRetry === 'function') {
    setTimeout(scheduleAuthRetry, 100);
  }
}











